import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { AuthInfo } from '../../types/contexts/AuthContext'
import { ResetCredentials } from '../../types/user/auth'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useResetPassword() {
  const { t } = useTranslation(['auth', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { poster } = useFetch()
  const { saveAuthInfo } = useAuth()

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const resetPassword = async (resetCredentials: ResetCredentials) => {
    setLoading(true)
    try {
      const data = await poster<AuthInfo>(
        `${CONFIG.BOUNCE_API}/api/v1/account/password/reset`,
        resetCredentials,
        'application/json'
      )
      if (data) {
        saveAuthInfo(data)
        setSuccess(t('auth:password.successfully-reseted'))
        setError(null)
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }
  return { resetPassword, loading, error, success, resetState }
}
